import { add } from '../../../_modules/i18n';
import nl from './nl';
import fa from './fa';
import de from './de';
import ru from './ru';
export default function () {
    add(nl, 'nl');
    add(fa, 'fa');
    add(de, 'de');
    add(ru, 'ru');
}



//////////////////
// WEBPACK FOOTER
// /Users/emmanuelpiguet/Documents/Web/Local/icmc/app/public/wp-content/themes/icmc/node_modules/mmenu-js/dist/core/oncanvas/translations/translate.js
// module id = 33
// module chunks = 0